import styled from '@emotion/styled';
import { type ITheme, Link } from '../../../../ui';
import themed from '../../../../ui/themer/themed';
import Responsive from '../../../../ui/utils/Responsive';
import { theme } from '../../../shared/styles';

export const StyledShortcut = styled(Link)<{}, ITheme>`
	width: 100%;
	height: 100px;
	overflow: hidden;
	position: relative;
	gap: 16px;
	display: flex;
	justify-content: start;
	align-items: center;

	padding: 32px 24px;
	border-radius: 12px;
	background: #f7f7f7;

	transition: 0.1s all;

	svg {
		display: none;
	}

	&:hover {
		cursor: pointer;
		text-decoration: none;
		background: ${themed(({ background }) => background.light)};
	}

	&:focus-visible {
		outline: ${theme.button?.primary?.focus?.outline};
		border-radius: 12px;
	}

	@media (${Responsive.getMediaQueryForBreakpoint('tablet')}) {
		height: 68px;
		gap: 12px;
		padding: 16px 12px;
	}
`;
export const StyledShortcutDiv = styled(StyledShortcut.withComponent('div'))`
	display: flex;
	align-items: center;
	justify-content: center;
`;
